import React, { useState, useEffect, useRef } from 'react';
import { HiArrowLeft } from "react-icons/hi2";
import {FaCamera} from "react-icons/fa";
import {Navbar, Button } from 'flowbite-react';
import logdetails from "../img/log-details.png";
import { useSearchParams, useNavigate } from "react-router-dom";
import { MdCheckCircle } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";
import { handleImageUpload } from "./handler"

const LogDetails = (props) => {
  const vehicleLogRef = useRef(null);
  const cssForImageCard = {
    success : {
      imageDiv: 'mt-2 mb-10 custom-card-success border rounded-md items-center shadow-none p-10',
    },
    standard : {
      imageDiv: 'mt-2 mb-10 custom-card border rounded-md items-center shadow-none p-10',
    }
  }
  
  const selectedProfileType = JSON.parse(sessionStorage.getItem("selectedProfileType"));

  const navigate = useNavigate();

  let [vehicleImage, setVehicleImage] = useState();
  let [validation, setValidation] = useState({ show: false, message: "", class: "" });

  
  let [userUploadedLogPic, setUserUploadedLogPic] = useState(false)
  let [logPicLoading, setLogPicLoading] = useState(false)

  let [validationOnSubmit, setValidationOnSubmit] = useState(false)
  let [showButton, setShowButton] = useState(false)
  

  useEffect(()=>{
    setVehicleImage(logdetails)
    for(let requiredItems of props.memberRequirement.requiredDocuments[props.itemIndex].requiredItems) {
      if(requiredItems.value !== "" && requiredItems.itemName === 'vehicleLog') {
        setVehicleImage(requiredItems.url)
        setUserUploadedLogPic(true)
      }
    }
  }, [])

  const handleVehicleLogClick = () => {
    vehicleLogRef.current.click();
  }

  const handleFileChange = async (e, itemName) => {
    let file = e.target.files[0]
    if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type) || (file.size / 1000000 ) > 7) {
      setValidation({ show: true, message: "", class: "" })
      return
    }
    setLogPicLoading(true)
    await handleImageUpload(file, itemName, "vehicleLog",
    setVehicleImage, setValidation, setUserUploadedLogPic,
    setShowButton, props.memberRequirement,props.setMemberRequirement, props.itemIndex, navigate,selectedProfileType.profileId)
    setValidationOnSubmit(false)
    setLogPicLoading(false)
    
  }


  return (
    <>
    <Navbar
        fluid={true}
        rounded={true}
        className='shadow mb-3' style={{position:'fixed', width:'100%', top:'0'}}>  
            <Navbar.Brand onClick={()=>{props.setOpenUploadDocument({openDocument : false , documentType : ""})}}>
                  <HiArrowLeft className='h-10 w-5 ml-2' />
            </Navbar.Brand>
    </Navbar>
    <div className='p-6  max-w-md m-auto' style={{paddingTop:'80px'}}>
        
        <h5 className="text-2xl mb-2 font-bold tracking-tight text-gray-900 dark:text-white">
        Vehicle Log
        </h5>
        <p className='mb-8 text-gray-600'>Below are the required document to setup Rydesend account.</p>
        { validationOnSubmit && 
          <div className="error-msg">
            <span>Need to Upload Vehicle Log before submitting for verification</span>
          </div>
        }

        {
          userUploadedLogPic && 
          <div className="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white" style={{paddingRight: '10px'}}>
            <MdCheckCircle style = {{ color: '#15BE44' }}/>
          </div>
        }
        
        <label className='font-bold tracking-tight text-gray-900'>Log Image</label>
        <div className={ userUploadedLogPic ?  cssForImageCard.success.imageDiv : cssForImageCard.standard.imageDiv}>
              { validation.show &&
                  
                  <div className="error-msg">
                      <span >Invalid image. Only images of type png, jpg, jpeg with size below 7mb can be uploaded</span>
                  </div>
              
              }
                <img src={vehicleImage}
            className="w-auto m-auto"
            alt="Ryde" />
            <p className='text-xs text-gray-400 tracking-tight mt-2'><i>Your LTA vehicle log must show these 3 things:<br /> <br />
            1. License Plate Number<br /> 02. Vehicle type is Z10/Z11<br /> 03. Valid expiry date</i></p>

            <p className='text-xs text-gray-400 tracking-tight mt-2'><i>You may visit <a>LTA ONE MOTORING</a> website to retrieve
            your vehicle log</i></p>


            <Button  pill={true} className='mt-5 m-auto w-sm pr-4' onClick={handleVehicleLogClick}>
            {
              logPicLoading ? <BsThreeDots className="h-5 w-10" /> : <FaCamera className="h-5 w-10" />
            }
            <label // for="file-upload"
             className="relative cursor-pointer rounded-md font-medium">
                      <span>{logPicLoading ? 'Saving' : userUploadedLogPic ? 'Replace' : 'Upload' }</span>
                      
                    </label> 
          </Button>
          <input 
            id="file-upload" 
            name="file-upload"
            type="file"
            ref={vehicleLogRef}
            style={{display: 'none', width:'0px'}}
            onChange={(event)=>{handleFileChange(event,"vehicleLog")}}/>
        </div>

        <Button className='bg-primary w-full mt-5' pill={true} disabled={false} onClick={()=>{
          if(userUploadedLogPic ) {
            props.setOpenUploadDocument({
              openDocument: false,
              documentType: "",
            });
          } else {
            setValidationOnSubmit(true)
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
          }
        }}>
                    Save
                  </Button>
    </div>
   
    </>
  )
}

export default LogDetails;